import { api } from './api';
import type {
  MfaStatusResponse,
  MfaSetupResponse,
  MfaVerifySetupResponse,
  RecoveryCodesResponse,
  RegenerateRecoveryCodesResponse,
  MfaChallengeVerifyResponse,
  VerifyIdentityRequest,
  VerifyIdentityResponse,
} from '../types/mfa';

interface VerifyChallengeRequest {
  mfa_token: string;
  code: string;
  method?: 'totp' | 'email' | 'recovery_code';
}

interface SendEmailCodeRequest {
  mfa_token: string;
}

interface SendEmailCodeResponse {
  success: boolean;
  message?: string;
  expires_in?: number;
  error?: string;
}

export const mfaApi = {
  status: () => api.get<MfaStatusResponse>('/api/auth/mfa/status'),

  setupTotp: () => api.post<MfaSetupResponse>('/api/auth/mfa/totp/setup'),

  verifyTotpSetup: (code: string) =>
    api.post<MfaVerifySetupResponse>('/api/auth/mfa/totp/verify', { code }),

  // Step-up auth must precede this. Caller hits /verify-identity first.
  disableTotp: () =>
    api.delete<{ success: boolean; message?: string; error?: string; step_up_required?: boolean }>(
      '/api/auth/mfa/totp'
    ),

  recoveryCodesStatus: () => api.get<RecoveryCodesResponse>('/api/auth/mfa/recovery-codes'),

  regenerateRecoveryCodes: () =>
    api.post<RegenerateRecoveryCodesResponse>('/api/auth/mfa/recovery-codes/regenerate'),

  // Challenge endpoints — no auth header (the MFA token authenticates the user
  // for that one verification).
  verifyChallenge: (req: VerifyChallengeRequest) =>
    api.post<MfaChallengeVerifyResponse>('/api/auth/mfa/verify', req, { skipAuth: true }),

  sendEmailCode: (req: SendEmailCodeRequest) =>
    api.post<SendEmailCodeResponse>('/api/auth/mfa/email/send', req, { skipAuth: true }),

  // Step-up authentication. Called from authenticated UI before invoking a
  // sensitive action (delete org, disable MFA, regenerate recovery codes).
  verifyIdentity: (req: VerifyIdentityRequest) =>
    api.post<VerifyIdentityResponse>('/api/auth/verify-identity', req),
};
